import React from 'react';
import type { LucideIcon, LucideProps } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Any lucide-react icon, or a component with the same props (e.g. WhatsAppIcon). */
export type IconComponent = LucideIcon | React.FC<LucideProps>;

interface IconProps {
  icon: IconComponent;
  size?: number;
  className?: string;
}

/**
 * Design-system icon: lucide-react with the Figma stroke (2px at every size).
 * Colour comes from `currentColor`, so pass a text colour class.
 */
const Icon: React.FC<IconProps> = ({ icon: Glyph, size = 18, className }) => (
  <Glyph size={size} strokeWidth={2} absoluteStrokeWidth aria-hidden className={cn('tw-shrink-0', className)} />
);

export default Icon;
